<template>
  <div>
    <template v-if="initializing">
      <div class="uk-container">
        <div class="uk-margin" uk-spinner="ratio: 3"></div>
      </div>
    </template>
    <template v-else-if="initializationError">
      <div class="uk-container">
        <p>Error initializing. Please refresh the page.</p>
      </div>
    </template>
    <template v-else>
      <PromotionPocApprovalForm
        :user="user"
        :project="project"
        :request="request"
        :google-drive-url="googleDriveUrl"
      />
    </template>
  </div>
</template>

<script>
import PromotionPocApprovalForm from '../pages/PromotionPocApprovalForm.vue'
import axios from 'axios'
import swal from 'sweetalert2'
import { serverUrl } from '../../common/helper/serverUrl'

export default {
  components: {
    PromotionPocApprovalForm,
  },

  metaInfo: {
    title: 'Feedback Form',
  },

  props: ['routeProjectId', 'routeApprovalToken'],

  data() {
    return {
      initializing: false,
      initializationError: false,

      project: {},
      request: {},
      user: '',
      googleDriveUrl: '',
    }
  },

  computed: {
    initializeUrl() {
      return serverUrl('/poc-approval-form/initialize')
    },
  },

  methods: {
    async initialize() {
      this.initializing = true
      axios.get(this.initializeUrl, {
        params: {
          id: this.routeProjectId,
          token: this.routeApprovalToken,
        },
      })
        .then((resp) => {
          this.project = resp.data.project
          this.request = resp.data.request
          this.user = resp.data.user
          this.googleDriveUrl = resp.data.googleDriveUrl
        })
        .catch(() => {
          this.initializationError = true
          swal('Error', 'Error initializing. Please refresh the page.', 'error')
        })
        .then(() => {
          this.initializing = false
        })
    },
  },

  created() {
    this.initialize()
  },
}
</script>
